import { ChangeCheckInButtonField } from '../calendarEntry/changeCheckInButtonFIeld';
import { CheckInDateEntryField } from '../calendarEntry/checkInDateEntryField';
import { CalendarDateItemType } from '../hook/calendar/useCalendarDateItem';
import { CalendarTimeItemType } from '../hook/calendar/useCalendarTimeItem';

interface ChangeCheckInDateFieldProps {
  calendarInfo: {
    header: {
      label: string;
      onPrev: () => void;
      onNext: () => void;
    };
    date: CalendarDateItemType[][];
    time: CalendarTimeItemType[];
  };
  disabled: boolean;
  onClickChangeCheckIn: () => void;
}
export const ChangeCheckInDateField = ({
  calendarInfo,
  disabled,
  onClickChangeCheckIn,
}: ChangeCheckInDateFieldProps) => {
  return (
    <div
      className={'change-check-in-date-field'}
      style={{
        height: '80%',
      }}
    >
      <CheckInDateEntryField props={calendarInfo} />
      <ChangeCheckInButtonField
        disable={disabled}
        onClick={onClickChangeCheckIn}
      />
    </div>
  );
};
